import { render, staticRenderFns } from "./Gate.vue?vue&type=template&id=6b705e2d&"
import script from "./Gate.vue?vue&type=script&lang=js&"
export * from "./Gate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports